export const APP_VERSION = 'v60';
